import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import axios from "axios";
import { getPracticeId } from "../../config/practice";


const EstimView = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

 const fetchData = async () => {
      try {
   const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/${getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );
      
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };
  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);


  const formatDate = (date) => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "";
  };

  return (
 <div
  id={examData ? "report-ready" : undefined}
  className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
>
  <div className="w-full max-w-4xl flex flex-col border border-gray-300 rounded-md p-8 shadow-sm bg-white">
        {/* Header */}
        <div className="flex items-start w-full justify-center mb-4">
          <img src={BrianyCareLogo} alt="Logo" className="w-16 h-16 mr-3" />
          <div>
            <h1 className="text-xl font-bold text-start text-blue-600 leading-none">C-HIM</h1>
            <p className="text-sm font-semibold mt-1">Center for Hypertension & Internal Medicine</p>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center font-bold text-base mb-4">ESTIM</h2>

        {examData ? (
          <>
          
    <div className="flex justify-start text-sm text-left w-full mb-4">
                                                    <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                                                      <span><strong>MR No#</strong></span>
                                                      <span>:</span>
                                                      <span>{examData.patientDetails.patientid}</span>
                                                  
                                                      <span><strong>Name</strong></span>
                                                      <span>:</span>
                                                      <span>{examData.patientDetails.pat_name}</span>
                                                  
                                                      <span><strong>Age</strong></span>
                                                      <span>:</span>
                                                      <span>{examData.patientDetails.age}</span>
                                                  
                                                      <span><strong>Exam Date</strong></span>
                                                      <span>:</span>
                                                      <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                                                  
                                                      <span><strong>Date of Birth</strong></span>
                                                      <span>:</span>
                                                      <span>{dayjs(examData.pat_dob, "DD-MM-YYYY").format("MMM D, YYYY")}</span>
                                                  
                                                     
                                                    </div>
                                                  </div>
            {/* Table */}
            <div className="w-full overflow-x-auto">
              <table className="w-full border border-collapse text-sm text-center">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-2 py-1">Date of Service</th>
                    <th className="border px-2 py-1">Start Time</th>
                    <th className="border px-2 py-1">End Time</th>
                    <th className="border px-2 py-1">Treatment Area</th>
                    <th className="border px-2 py-1">Pain Scale (1-10)</th>
                    <th className="border px-2 py-1">Range of Motion (1-10)</th>
                    <th className="border px-2 py-1">Program #</th>
                    <th className="border px-2 py-1">Dosage</th>
                    <th className="border px-2 py-1">Improve Function</th>
                  </tr>
                </thead>
                <tbody>
                  {examData.tableData.map((row, i) => (
                    <tr key={i} className="border-t">
                      <td className="border px-2 py-1">{dayjs(row.date).format("MM/DD/YYYY")}</td>
                      <td className="border px-2 py-1">{row.startTime}</td>
                      <td className="border px-2 py-1">{row.endTime}</td>
                      <td className="border px-2 py-1">{row.treatmentArea}</td>
                   <td className="border px-2 py-1">
  <div className="flex items-center justify-center gap-1 border border-gray-300 rounded px-1 py-0.5">
    <span className="w-6 text-center border-r">{row.painScaleLeft}</span>
    <span className="w-6 text-center">{row.painScaleRight}</span>
  </div>
</td>

<td className="border px-2 py-1">
  <div className="flex items-center justify-center gap-1 border border-gray-300 rounded px-1 py-0.5">
    <span className="w-6 text-center border-r">{row.rangeMotionLeft}</span>
    <span className="w-6 text-center">{row.rangeMotionRight}</span>
  </div>
</td>

                      <td className="border px-2 py-1">{row.program}</td>
                      <td className="border px-2 py-1">{row.dosage}</td>
                      <td className="border px-2 py-1">{row.improveFunction}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default EstimView;
